// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"423":"8ea6a480","497":"95f6912d"}[chunkId] + ".js";
};